import { render, staticRenderFns } from "./VerEnvio.vue?vue&type=template&id=4af07cba&scoped=true&"
import script from "./VerEnvio.vue?vue&type=script&lang=js&"
export * from "./VerEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af07cba",
  null
  
)

export default component.exports